import { Injectable } from '@angular/core';
import { FormActionHandlerService } from './base.service';
import { FormStatusService } from '../status.service';
import { SwalService } from '../../../fastlane-common/services/swal.service';
import { FormDataService } from '../data.service';
import { FormShareService } from '../share.service';
import { UserContextService } from '../../../user/services/user-context.service';
import { EmailService } from '../../../email/services/email.service';
import { FormStatus, formStatus } from 'app/form/form.constants';
import { SweetAlertOptions } from 'sweetalert2';


@Injectable()
export class RdReturnToManagerActionHandlerService extends FormActionHandlerService {
  constructor(
    private dataService: FormDataService,
    private statusService: FormStatusService,
    private swal: SwalService,
    private shareService: FormShareService,
    private userContext: UserContextService,
    private emailService: EmailService
  ) {
    super();
  }

  exec(): Promise<any> {
    const that = this;
    const currentStatus = this.shareService.form.statuses[0].status;
    const reviewerRole = this.reviewerRoleFor(currentStatus);

    const swalOptions = <SweetAlertOptions>{
      title: 'Return this form to the program manager?',
      inputPlaceholder:
        'Enter the reason for returning this form. This will be emailed to the program manager and saved to the form\'s status history.',
      type: 'question',
      confirmButtonText: 'Yes, Return to Manager',
      allowOutsideClick: false
    };
    const emptyReasonMessage =
      'A reason must be entered in order to return the form.';

    return new Promise((resolve, reject) => {
      that.swal
        .textarea(swalOptions, 'required', emptyReasonMessage)
        .then(reason => {
          that.swal.load('Returning form to the program manager...');

          that.statusService.changeStatus(formStatus.received);
          const receivedEntry = that.shareService.form.statuses[0];
          if (receivedEntry) {
            receivedEntry.comment = reason;
          }

          that.dataService.saveForm().subscribe(
            () => {
              that.notifyManager(reviewerRole, reason).then(() => {
                that.swal
                  .success({
                    title: 'Form Returned',
                    text:
                      'The form is back in Received status and the program manager has been notified.'
                  })
                  .then(() => resolve())
                  .catch(() => resolve());
              });
            },
            errorSaving => {
              if (errorSaving === 409) {
                reject(errorSaving);
              } else {
                reject(
                  'We were unable to return the form. Please try again later.'
                );
              }
            }
          );
        })
        .catch(() => resolve());
    });
  }

  private reviewerRoleFor(currentStatus: FormStatus): string {
    if (currentStatus === formStatus.pendingAssistantDirectorReview) {
      return 'Assistant Director';
    }
    if (currentStatus === formStatus.pendingDirectorReview) {
      return 'Director';
    }
    return 'Reviewer';
  }

  private notifyManager(reviewerRole: string, reason: string): Promise<void> {
    const that = this;
    return new Promise(resolve => {
      const projectInfo = that.shareService.projectBase.projectInfo;
      const form = that.shareService.form;
      const projectGuid = that.shareService.formId.projectGuid;
      const currentUser = that.userContext.currentUser;
      const returnedByName = currentUser
        ? `${currentUser.firstName || ''} ${currentUser.lastName || ''}`.trim()
        : '';

      that.emailService
        .sendRdReviewReturnedToManagerNotification(
          projectInfo,
          form,
          projectGuid,
          returnedByName,
          reviewerRole,
          reason
        )
        .subscribe(() => resolve(), () => resolve());
    });
  }
}
